<template>
  <div>
    <span class="home_header_text" title="回到首页" @click="goHome"
      >红砖智库系统</span
    >
    <div class="pending-items-search" v-if="!unApproveMember">
      <input
        v-model="keyword"
        placeholder="请输入你要搜索的文章关键词"
        @keyup.enter="handleSearchClick"
      />
      <i
        class="iconfont icon-sousuo"
        @click="handleSearchClick"
        style="cursor: pointer"
      ></i>
    </div>

    <div class="home_header_right_text">
      <span
        class="user-avatar"
        :style="`background-image: url(${avatarLink})`"
      ></span>
      <el-dropdown v-if="showNameFlag">
        <span class="el-dropdown-link" style="color:#fff">
          <span
            >欢迎您，{{ username }}
            <el-tag
              style="margin: 0px 3px"
              type="success"
              v-for="(roleName, index) of roleNames"
              :key="index"
              >{{ roleName }}</el-tag
            >
          </span>
          <i class="el-icon-arrow-down identity-link"></i>
        </span>
        <el-dropdown-menu
          slot="dropdown"
          style="background-image: url('static/images/UCenterMenu.png');"
        >
          <el-dropdown-item disabled style="color: #606266;font-size: 13px">
            <div>用户：{{ username }}</div>
            <div>手机号：{{ userId }}</div>
            <div>
              角色：<el-tag
                style="margin: 0px 3px"
                type="success"
                v-for="(roleName, index) of roleNames"
                :key="index"
                >{{ roleName }}</el-tag
              >
            </div>
            <div>机构：{{ hospitalName ? hospitalName : "暂无医院" }}</div>
            <div>
              <span v-if="latestLoginRcrd"
                >上次访问时间：{{
                  latestLoginRcrd.loginTm | datetimeFormat
                }}</span
              >
              <span v-else>上次访问时间：首次访问</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item
            class="iconfont"
            icon="el-icon-tickets"
            divided
            @click.native="uCenter"
            v-if="!unApproveMember"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item
            class="iconfont"
            v-if="userDeptData.length > 1"
            icon="el-icon-sort"
            divided
            @click.native="changeIdentity"
            >切换角色</el-dropdown-item
          >
          <el-dropdown-item
            class="iconfont"
            icon="el-icon-circle-close"
            @click.native="sureLogout"
            >退出</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import { mapState } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      superPower: false,
      unApproveMember: false,
      currUserDeptId: -1,
      userDeptData: [],
      username: "",
      departmentName: "",
      hospitalName: "",
      roleName: "",
      roleNames: [],
      userId: "",
      avatarLink: "",
      keyword: "",
      showNameFlag: true
    };
  },

  created() {
    this.showUsername();
    this.findUserAllDept(true);
    this.currUserDeptId = this.$store.state.headerStore.currUserDeptIdCache;
    this.userDeptData = this.$store.state.headerStore.userDeptS;
    // this.superPower = this.$store.state.userPowerStore.superPower
    this.$store.dispatch("getUserInfo");
    this.getAuth();
  },

  watch: {
    //页数变化直接缓存
    userDeptS(newVal) {
      this.userDeptData = newVal;
    },
    //页数变化直接缓存
    currUserDeptIdCache(newVal) {
      this.currUserDeptId = newVal;
    },

    userPower(newVal) {
      this.superPower = this.$store.state.userPowerStore.superPower;
      this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
    },

    //回到首页后搜索框清空
    "$route.path"(newVal) {
      if (newVal == "/dashboard") {
        this.keyword = "";
      }
    },
    refreshHeadFlag(newVal, oldVal) {
      if (newVal) {
        //重新触发刷新数据
        this.showUsername();
        this.$store.commit("changeRefreshFlag", { headFlag: false });
      }
    }
  },

  computed: {
    departmentShowName() {
      let name = this.departmentName;
      let result = "";
      if (!name) {
        return;
      }
      if (name.length <= 6) {
        result = name;
      } else if (name.length > 6 && name.length <= 13) {
        result = name.substring(0, 7) + "...";
      } else if (name.length > 13) {
        result = name.substring(0, 7) + "..." + name.substring(9, 12);
      }
      return result;
    },

    ...mapState({
      userDeptS: state => state.headerStore.userDeptS,
      currUserDeptIdCache: state => state.headerStore.currUserDeptIdCache,
      userPower: state => state.userPowerStore.userPower,
      latestLoginRcrd: state => state.userModule.latestLoginRcrd,
      refreshHeadFlag: state => state.userModule.refreshHeadFlag
    })
  },

  methods: {
    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.superPower = this.$store.state.userPowerStore.superPower;
        this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
      });
    },

    //点击回到首页
    goHome() {
      this.$store.dispatch("clearDiscussCondition");
      this.$router.push({
        path: "/dashboard"
      });
    },

    sureLogout() {
      cookie.deleteCookie("token");
      this.$router.push({ path: "/Login" });
      //清空缓存数据
      this.clearCacheData();
    },

    uCenter() {
      this.$router.push({ path: "/uCenter/info" });
    },

    personalData() {
      this.$router.push({ path: "/uCenter/personal" });
    },

    //改变身份
    changeIdentity() {
      this.$router.push({
        path: "/deptSelect",
        query: {
          reelect: true
        }
      });
    },

    commitUserDept(dept) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          departmentId: dept.id
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/user/selectIdentity", obj)
        .then(value => {
          if (value.data.code === "00000") {
            Message.success({ message: "机构切换成功", showClose: true });
            this.$router.push({
              path: "/home"
            });
            //设置当前用户的身份
            this.$store.dispatch("setCurrUserDeptIdCache", dept.id);
            this.departmentName = dept.name;
            this.clearCacheData();
          }
        });
    },

    clearCacheData() {
      this.$store.dispatch("clearDeptListData");
    },

    //flag为true 的是菜单弹出
    findUserAllDept(flag) {
      if (flag) {
        this.$store.dispatch("findUserAllDept");
      }
    },

    showUsername() {
      let token = cookie.getCookie("token");
      let that = this;
      that.showNameFlag = false;
      http
        .post(window.config.api.baseUrl + "/eims-api/user/currLoginInfo", {
          token: token,
          data: {}
        })
        .then(response => {
          let name = response.data.data.name;
          let dName = response.data.data.departmentName;
          let hospitalName = response.data.data.hospitalName;
          let departmentId = response.data.data.departmentId;
          let roleName = response.data.data.roleName;
          let userId = response.data.data.userId;
          let avatar = response.data.data.avatar;
          that.username = name;
          that.departmentName = dName;
          that.hospitalName = hospitalName;
          that.roleName = roleName;
          that.roleNames = roleName.split(
            this.$store.state.userPowerStore.ROLE_CODE_OR_NAME_SEPARATOR
          );
          that.userId = userId;
          that.avatarLink = window.config.avatar.baseUrl + "/" + avatar;
          //设置当前用户的身份
          that.$store.dispatch("setCurrUserDeptIdCache", departmentId);
        })
        .finally(() => {
          that.showNameFlag = true;
        });
    },

    //搜索框查询
    handleSearchClick() {
      this.$router.push({
        path: "/article/articleSearch",
        query: { keyword: this.keyword }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home_header_text {
  color: white;
  text-align: center;
  font-size: 30px;
  float: left;
  font-weight: bold;
  margin-top: 10px;
  cursor: pointer;
}
.pending-items-search {
  width: 38%;
  float: left;
  margin-top: 15px;
  margin-left: 30px;
  input {
    padding-left: 15px;
    width: 100%;
    height: 35px;
    border-style: none;
    border-color: unset;
    border-radius: 15px;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    background: rgb(255, 250, 250);
    outline-color: #f9846b;
  }
  .icon-sousuo {
    margin-left: -35px;
    color: #f9836a;
  }
}
.home_header_right_text {
  float: right;
  color: white;
  margin: 14.5px 0;
  .user-avatar {
    vertical-align: middle;
    display: inline-block;
    width: 40px;
    height: 40px;
    background-size: cover;
    border-radius: 30px;
    border: #e8e6e6 2px solid;
  }
  .el-dropdown-link {
    cursor: pointer;
    &:hover {
      transform: rotate(180deg);
    }
    &:focus {
      outline: none;
    }
    .identity-link {
      transform: rotate(0deg);
      transition-duration: 0.5s;
    }
  }
}
.el-dropdown-menu__item--divided:before {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/header.vue